"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicTokenContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.publicTokenContract = c.router({
    getTokenRedemptionOption: {
        method: 'GET',
        path: '/token-redemption-option/:id/',
        pathParams: zod_1.z.object({
            id: zod_1.z.coerce.number(),
        }),
        responses: {
            200: models_1.ZTokenRedemptionOptionSelectResponse,
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
    getTokenRedemptionOptions: {
        method: 'GET',
        path: '/token-redemption-options',
        responses: {
            200: models_1.ZTokenRedemptionOptionsItem.array(),
        },
    },
    getTokenRedemptionOptionBySlug: {
        method: 'GET',
        path: '/token-redemption-option/slug/:slug',
        pathParams: zod_1.z.object({
            slug: zod_1.z.string(),
        }),
        responses: {
            200: models_1.ZTokenRedemptionOptionSelectResponse,
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
    getYouMightAlsoLikeOptions: {
        method: 'GET',
        path: '/you-might-also-like',
        responses: {
            200: models_1.ZTokenRedemptionOptionsItem.array(),
        },
    },
}, {
    pathPrefix: '/public',
});
//# sourceMappingURL=token.public.contract.js.map